import React, { FC, ReactNode, useCallback, useEffect, useRef, useState } from 'react'
import { AnimatePresence } from 'framer-motion'
import S from './Dropdown.styles'

interface DropdownProps {
  content?: ReactNode
  children: ReactNode
  /** rem unit value */
  maxWidth?: number | string
  /** show the thing */
  show?: boolean
  /** Offsets the edge of the dropdown from the edge of the viewport */
  edgeOffset?: number
}

const Dropdown: FC<DropdownProps> = ({ children, maxWidth = '100%', show = false, content, edgeOffset = 0 }) => {
  const node = useRef<HTMLDivElement>(null)
  const [maxHeight, setMaxHeight] = useState('100%')

  const updateHeight = useCallback(() => {
    if (node.current) {
      const rect = node.current.getBoundingClientRect()
      const value = window.innerHeight - (rect.top + edgeOffset)
      setMaxHeight(`${value}px`)
    }
  }, [edgeOffset])

  useEffect(() => {
    // Initial height setting
    updateHeight()

    // Update height when window is resized
    window.addEventListener('resize', updateHeight)

    // Cleanup
    return () => {
      window.removeEventListener('resize', updateHeight)
    }
  }, [updateHeight, content])

  return (
    <div style={{ position: 'relative' }}>
      {children}
      <AnimatePresence>
        {show && (
          <S.Dropdown
            ref={node}
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            $maxWidth={maxWidth}
            $maxHeight={maxHeight}>
            {content}
          </S.Dropdown>
        )}
      </AnimatePresence>
    </div>
  )
}

export default Dropdown
